import { useQuery } from "react-query";
import { WPPost } from "../../../constants/types";
import { PagePostTypeAcf } from "../../../constants/types/acf";
import { useBaseUrl } from "../../../services/app-state";
import { fetchJSON } from "../../../utils/ajax";

export const usePageDataById = (id: number) => {
    const baseUrl = useBaseUrl();

    return useQuery(["page-by-id", id], () =>
        fetchJSON<WPPost<PagePostTypeAcf>>(`${baseUrl}/wp-json/wp/v2/pages/${id}`),
    );
};
